import React from 'react';
import {
  ComponentWrapper, ComponentVerticalSpacing, Card, Button
} from 'day8-react/build/new-components';
import PageLayout from '../layouts/page';

const legalDocs = [
  {
    title: 'Booking Terms & Conditions',
    subheading: 'You\'re almost booked and at the top of the mountain. Get your Ts & Cs here.',
    image: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2019/10/office-2.jpg',
      alt: 'Office with people working in'
    },
    cta: {
      text: 'Download',
      link: '/terms-and-conditions',
      external: true,
      buttonType: 'btn--bare',
      icon: 'attachment',
      iconFlip: true
    }
  },
  {
    title: 'Privacy Policy',
    subheading: 'Want to get the down-low on all things privacy? Read our policy here.',
    image: {
      url: 'https://assets.theskiweek.com/wp-content/uploads/2020/07/day-5-4.jpg',
      alt: 'Pond skim'
    },
    cta: {
      text: 'Download',
      link: 'https://cdn.theskiweek.com/documents/legal/tsw_privacy_policy_2018-05-17.pdf',
      buttonType: 'btn--bare',
      external: true,
      icon: 'attachment',
      iconFlip: true
    }
  },
  {
    title: 'Mobile app terms & conditions',
    subheading: 'It’s the go-to for all event communications. Get up to speed on the policy right here.',
    image: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2019/10/mobile.jpg',
      alt: 'Person holding mobile phone'
    },
    cta: {
      text: 'Download',
      link: 'https://cdn.theyachtweek.com/documents/legal/MobileApp-TermsOfUse-FinalDay8.pdf',
      buttonType: 'btn--bare',
      icon: 'attachment',
      iconFlip: true
    }
  }
];

const Legal = () => (
  <PageLayout page={{ seo_title: 'Legal | The Ski Week' }}>
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        <div className="top-title text-center max-width-xs margin-auto text-component">
          <span className="d8-u-color-primary d8-u-ls-sm d8-u-text-bold">OUR COMPANY</span>
          <h1>Legal</h1>
          <p className="margin-top-xl">
            Please read our full Terms of Service (“Terms” or “Terms of Service”) carefully before using the
            theskiweek.com website (the “Site”), the downloadable application (the “Application”), and all services of
            The Ski Week provided therein and operated by Day8, Ltd., (“Day8”, “us”, “we”, or “our”).
          </p>
          <Button className="margin-top-md" link="/full-legal" text="Read full legal terms" />
        </div>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        <div className="d8-l-4-col-grid">
          {legalDocs.map((d, i) => (
            <Card
              key={i}
              template="ImageCard"
              imageCardTemplate="VerticalSplit"
              heading={d.title}
              subheading={d.subheading}
              image={d.image}
              cta={d.cta}
            />
          ))}
        </div>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
  </PageLayout>
);

export default Legal;
